import React, { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import BoxGiftIcon from '@src/assets/icons/box_gift.png';
import { getFakeEndTimeDiscountForPackage } from '@src/services/package';
import { COLOR } from '@src/styles/color';
import CopyableButton from '@src/components/CopyableButton';
import Countdown from 'react-countdown';
import { DEFAULT_TIME_TO_RESET_COUNTDOWN } from '@src/constants/voucher';
import { StyledVoucherBanner } from './index.style';
import CountdownTime from '../CountdownTime';
import CountdownBanner from '../CountdownBanner';

const NewVoucherBanner = ({ voucher, onBannerHeightChange }) => {
  const bannerRef = useRef(null);
  const [isCountdownCompleted, setIsCountdownCompleted] = useState(false); // Track if countdown is completed

  useEffect(() => {
    const updateBannerHeight = () => {
      if (bannerRef.current) {
        const newHeight = bannerRef.current.offsetHeight;
        onBannerHeightChange(newHeight);
      }
    };

    updateBannerHeight();
    window.addEventListener('resize', updateBannerHeight);

    return () => {
      window.removeEventListener('resize', updateBannerHeight);
    };
  }, [onBannerHeightChange]);

  const { i18n } = useTranslation();
  const { t, language } = i18n;

  const { detail = {}, title = {}, code = '', endTime, startTime } = voucher;

  const endTimeToShow =
    voucher?.fakeEndTimeForVoucher ||
    getFakeEndTimeDiscountForPackage({
      startTimeToCountdown: startTime,
      realEndTime: endTime,
      timeToResetCountdown: DEFAULT_TIME_TO_RESET_COUNTDOWN,
    });

  const renderer = ({ days, hours, minutes, seconds, completed }) => {
    if (completed) {
      setIsCountdownCompleted(true);
      return null;
    }

    return (
      <div className="countdown-box">
        <div className="countdown">
          <CountdownTime
            days={days}
            hours={hours}
            minutes={minutes}
            seconds={seconds}
          />
        </div>
      </div>
    );
  };

  return (
    <StyledVoucherBanner ref={bannerRef}>
      <div className="countdown-mobile">
        {endTime && !isCountdownCompleted && (
          <CountdownBanner
            date={new Date(endTimeToShow).getTime() + 100}
            backgroundColor="#fff9db"
          />
        )}
      </div>
      <div className="banner-container">
        <img src={BoxGiftIcon} alt="Voucher Banner" className="box-gift-icon" />

        <div className="content">
          <div className="title">{title[language]}</div>
          <div className="voucher-apply">
            <div className="description">
              {detail[language]}
              <span className="voucher-code">
                {` - ${t('voucherCode')}: ${code}`}
              </span>
            </div>
            <div className="voucher-code">
              <CopyableButton
                fontSize={18}
                color={COLOR.lightText}
                content={code}
                className="copyable-button"
              />
            </div>
          </div>
          <div className="voucher-code-mobile">
            <div className="">
              {t('voucherCode')}: {code}
            </div>
            <CopyableButton
              fontSize={16}
              color={COLOR.lightText}
              content={code}
              className="copyable-button"
            />
          </div>
        </div>

        <div className="countdown">
          {endTime && !isCountdownCompleted && (
            <Countdown
              date={new Date(endTimeToShow).getTime() + 100} // + 100ms to fix countdown bug
              renderer={renderer}
              onComplete={null}
            />
          )}
        </div>
      </div>
    </StyledVoucherBanner>
  );
};

export default NewVoucherBanner;
